import { createFileRoute } from '@tanstack/react-router';
import { VaultDepositPage } from '../components/pages/VaultTransferPage/VaultDepositPage';
import { z } from 'zod/mini';

const searchSchema = z.object({
  vaultId: z.optional(z.string()),
  accountId: z.optional(z.string()),
});

export const Route = createFileRoute('/account/vaults_/topup')({
  component: VaultDepositPage,
  validateSearch: searchSchema.parse,
});
